import { render, staticRenderFns } from "./HiDatatable.vue?vue&type=template&id=3a2e3256&scoped=true&"
import script from "./HiDatatable.vue?vue&type=script&lang=js&"
export * from "./HiDatatable.vue?vue&type=script&lang=js&"
import style0 from "./HiDatatable.vue?vue&type=style&index=0&id=3a2e3256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e3256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VDataTable})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
